import { API_URL } from "./sys";
export const FetchRetailers = `${API_URL}/retailers`;
export const SendOTP = `${API_URL}/otp/send`;
export const VerifyOTPs = `${API_URL}/otp/verify`;
export const get = async (endpoint, params) => {
  console.log(API_URL,'aa')
  const url = new URL(`${API_URL}${endpoint}`);
  if (params) {
    Object.entries(params).forEach(([key, value]) =>
        url.searchParams.append(key, value)
    );
  }
  const response = await fetch(url);
  if (response.ok) {
    if (response.status === 204) {
      console.log("No content returned from the server.");
      return null;
    } else if (response.status === 200) {
      const data = await response.json();
      return data;
    } else {
      const errorText = await response.text();
      throw new Error(`HTTP error ${response.status}: ${errorText}`);
    }
  }
};

export const post = async (endpoint, data) => {
  try {
    const response = await fetch(`${API_URL}${endpoint}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      console.log("REQUEST FINE");
    } else {
      const errorData = await response.json();
      if (errorData.message === "Failed to create retailer" && response.status === 500) {
        window.alert("A survey is already under progress/completed for this user, please contact your Admin for more info");
        return;
      } else if (response.status === 409) {
        return { ...errorData, status: response.status };
      } else {
        throw new Error(errorData.message || "Something went Wrong!");
      }
    }
    const responseData = await response.json();
    return responseData;
  } catch (error) {
    console.error("API call failed:", error);
    window.alert(`Error: ${error.message || "Network error"}`);
    throw error; 
  }
};